import { DateOptionType, FinanceType, HeaderOptionType, LanguageType, SettingVatFormType } from "@/enums/enums";
import { GetMerchantAddressModelDefault } from "@/helper/addressHelper";
import { GetCredential } from "@/helper/documentFacadeHelper";
import { GetPP30DocumentData } from "@/helper/pp30DocumentHelper";
import { PP30DocumentDetailModel, PP30OnlineViewModel } from "@/model/document/pp30DocumentModel";
import { SettingPP30DocumentTemplateModel } from "@/model/document/settingDocumentTemplate";

export function ConvertToPP30OnlineView(detail: any, financeType: FinanceType): PP30OnlineViewModel {
  const onlineViewModel: PP30OnlineViewModel = new PP30OnlineViewModel();
  if (detail) {
    const documentDetailModel: PP30DocumentDetailModel = new PP30DocumentDetailModel();
    documentDetailModel.version = detail.document.version;
    documentDetailModel.data = GetPP30DocumentData(detail.document.data);
    onlineViewModel.document = documentDetailModel;
    onlineViewModel.transactionId = detail.transactionId;
    onlineViewModel.transactionType = detail.transactionType;
    onlineViewModel.financeType = financeType;
    onlineViewModel.expenseType = detail.expenseType;
    onlineViewModel.template = detail.template ? detail.template.data : GetPP30SettingDocument(financeType);
    onlineViewModel.template.documentName.value =
      financeType === FinanceType.InFlow ? "Sales_Tax_Report" : "Purchase_Tax_Report";
    onlineViewModel.credential = GetCredential(detail.credential);
    onlineViewModel.headerOptionType = detail.headerOptionType;
  }
  return onlineViewModel;
}

export function GetPP30SettingDocument(financeType: FinanceType): SettingPP30DocumentTemplateModel {
  let settingTemplate = new SettingPP30DocumentTemplateModel();
  settingTemplate = {
    certified: {
      isShowUserCreateUrl: true,
      isShowUserApproveUrl: true,
      isShowUserCreateDate: true,
      isShowUserApproveDate: true,
      isShowUserApproveName: true,
      isShowUserCreateName: true,
      isShowMerchantStampUrl: true,
    },
    colorCode: "#6C6DF2",
    language: LanguageType.Th,
    merchantLogo: {
      value: "",
      isShowElement: true,
    },
    headType: {
      copyAmount: 0,
      originalAmount: 1,
      headerTitleType: HeaderOptionType.Original,
      isShowDocumentSet: false,
      isShowHeaderOptionType: false,
    },
    merchant: {
      isShowTextHeadOffice: true,
      merchantAddressTemplate: GetMerchantAddressModelDefault(),
      isCustomTextDisplay: false,
      merchantTitle: {
        value: "Organization_Title",
        isShowElement: true,
      },
      phoneNumber: {
        value: "",
        isShowElement: false,
      },
      email: {
        value: "",
        isShowElement: false,
      },
      website: {
        value: "",
        isShowElement: false,
      },
    },
    documentInfo: {
      formNumberTitle: {
        value: "Form_No",
        isShowElement: true,
      },
      formDateTitle: {
        value: "Tax_Period",
        isShowElement: true,
      },
      issueDateTitle: {
        value: "Approved_Date",
        isShowElement: true,
      },
      dateOptionType: DateOptionType.DateADType1,
      isCustomTextDisplay: false,
    },
    pp30TransactionCertified: {
      userCreateTitle: {
        value: "Report_Created_By",
        isShowElement: true,
      },
      userApproveTitle: {
        value: "Report_Approved_By",
        isShowElement: true,
      },
      isShowUserCreateUrl: true,
      isShowUserApproveUrl: true,
      isShowUserCreateDate: true,
      isShowUserApproveDate: true,
      isShowUserApproveName: true,
      isShowUserCreateName: true,
      isCustomTextDisplay: false,
      isShowQRCode: true,
    },
    settingVatFormType: SettingVatFormType.IncludedPreVat,
    documentName: {
      isShowElement: true,
      value: financeType === FinanceType.InFlow ? "Sales_Tax_Report" : "Purchase_Tax_Report",
    },
  };
  return settingTemplate;
}
